import componentInit from 'components/componentInit'
import main from 'main'
import $ from 'jquery'
import 'jquery.easing'
import 'jquery.scrollto'

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  mod.initComponents(parentElement)
}

let mod = {}

mod.initComponents = function(parentElement)
{
  let mainMenu = $(parentElement).find('#main-menu').get()
  let openMainMenuButton = $(parentElement).find('#main-menu-button').get()

  if(mainMenu && openMainMenuButton)
  {
    let closeMainMenuButton = $('<button class="close-main-menu"><div class="title">'+ main.framework.dict.ajax.close +'</div><div class="icon"></div></button>')
      .prependTo(mainMenu).get(0)

    $(openMainMenuButton).on('click.'+ module.id, function(event)
    {
      mod.open()
    })

    $(closeMainMenuButton).on('click.'+ module.id, function(event)
    {
      mod.close()
    })

    $(mainMenu).find('a[href^="#"]').on('click.'+ module.id, function(event)
    {
      let anchorName = $(event.currentTarget).attr('href').substring(1)
      let anchor = $('a[name="'+ anchorName +'"]').get(0)
      if(anchor)
      {
        event.preventDefault()

        let offset = -30 - $('#site-header').outerHeight(true)
        mod.close()
        $.scrollTo(anchor, {
          duration: 1000,
          easing: 'easeOutExpo',
          offset: offset
        })
      }
    })
  }
}

mod.open = function()
{
  $('body').toggleClass('main-menu-open', true)
}

mod.close = function()
{
  $('body').toggleClass('main-menu-open', false)
}

export default mod



// WEBPACK FOOTER //
// ./applications/publicFrontend/scripts/components/mainMenu.js